// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"14":"20dd99be","891":"a851bea5"}[chunkId] + ".css";
};